export const generate = (size, cb) => [...new Array(size)].map(cb);
export const loop = (size, cb) => [...new Array(size)].forEach(cb);
